<div class="fs-wrap">
    <div class="fs-head">
        <div>
            <h2 class="fs-title">Financial Summary</h2>
            <p class="fs-sub">{{ selectedMonthLabel }}</p>
        </div>
        <select class="fs-month-select" [(ngModel)]="selectedMonth" (change)="onMonthChange()">
            <option *ngFor="let month of months" [value]="month.value">
                {{ month.name }}
            </option>
        </select>
    </div>

    <div class="fs-grid">
        <!-- Total Revenue -->
        <div class="kpi-card">
            <div class="kpi-head">
                <span class="kpi-icon revenue"><i class="bi bi-arrow-up-right-circle"></i></span>
            </div>
            <div>
                <div class="kpi-label">Total Revenue</div>
                <ng-container *ngIf="isLoadingSummary; else revenueContent">
                    <div class="kpi-loader">
                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </ng-container>
                <ng-template #revenueContent>
                    <div class="kpi-value">
                        <span class="currency">{{ currencyFormat }}</span>{{ revenue }}
                    </div>
                </ng-template>
            </div>
        </div>

        <!-- Total Payout -->
        <div class="kpi-card">
            <div class="kpi-head">
                <span class="kpi-icon payout"><i class="bi bi-arrow-down-right-circle"></i></span>
            </div>
            <div>
                <div class="kpi-label">Total Payout</div>
                <ng-container *ngIf="isLoadingSummary; else payoutContent">
                    <div class="kpi-loader">
                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </ng-container>
                <ng-template #payoutContent>
                    <div class="kpi-value">
                        <span class="currency">{{ currencyFormat }}</span>{{ payout }}
                    </div>
                </ng-template>
            </div>
        </div>

        <!-- Gross Margin -->
        <div class="kpi-card">
            <div class="kpi-head">
                <span class="kpi-icon margin"><i class="bi bi-graph-up"></i></span>
            </div>
            <div>
                <div class="kpi-label">Gross Margin</div>
                <ng-container *ngIf="isLoadingSummary; else marginContent">
                    <div class="kpi-loader">
                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </ng-container>
                <ng-template #marginContent>
                    <div class="kpi-value">
                        <span class="currency">{{ currencyFormat }}</span>{{ margin }}
                        <span class="kpi-pct">· {{ marginPercent }}%</span>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>